import { UserConsumer } from './providers/UserProvider';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BreadcrumbGenerator from './BreadcrumbGenerator';
import SideDrawer from './SideDrawer';
import StandardAppBar from './StandardAppBar';
import { globalStyles as styles } from './style/gstheme';

class PageLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggleDrawer = (isOpen) => () => this.setState({ isOpen });

  render() {

    const { id, title, baseURL, classes, breadcrumb, options, showSidebar,
      layoutContainer, graph, optionParams, layoutTitle, includeJumps } = this.props;
    const { isOpen } = this.state;
    const contentClass = isOpen ? classes.sidebarNarrow : classes.sidebarFull;
    const Container = layoutContainer;

    const generator = layoutContainer ?
      <Container {...this.props}
        component={BreadcrumbGenerator}
        id={id}
        graph={graph}
        breadcrumb={breadcrumb} />
      :
      <BreadcrumbGenerator
        includeJumps={includeJumps}
        breadcrumb={breadcrumb}
        graph={graph} />;
    const TitleGenerator = layoutTitle;

    return (
      <UserConsumer>
        {({ user, hideMaintenance, hideRelease }) =>
          <div className={classes.applicationLayout}>
            <div className={classes.back} />
            <StandardAppBar title={title} />
            {showSidebar &&
              <SideDrawer
                baseURL={baseURL}
                optionParams={optionParams}
                id={id}
                options={options}
                toggleDrawer={this.toggleDrawer(!isOpen)}
                isOpen={this.state.isOpen}
              />
            }
            <div
              role="main"
              className={contentClass}
              style={(user.adminWindow && user.adminWindow.startTime && !hideMaintenance) || (!hideRelease) ? { top: '105px' } : {}}>
              {generator}
              <h1 data-test="page-layout-title" className={classes.layoutTitle}>{<TitleGenerator {...this.props} />}</h1>
              {this.props.children}
            </div>
          </div>
        }
      </UserConsumer>
    );
  }
}

PageLayout.defaultProps = {
  showSidebar: true,
  includeJumps: false
};

PageLayout.propTypes = {
  layoutContainer: PropTypes.func,
  showSidebar: PropTypes.bool,
  optionParams: PropTypes.string,
  includeJumps: PropTypes.bool,
  title: PropTypes.string.isRequired,
  baseURL: PropTypes.string.isRequired,
  graph: PropTypes.string,
  options: PropTypes.array.isRequired,
  breadcrumb: PropTypes.object.isRequired,
  classes: PropTypes.object
};

export default withStyles(styles)(PageLayout);